/* lcid/index */ function _(require, module, exports) {
    const invertKv = require(144) /* invert-kv */;
    const all = require(158) /* ./lcid.json */;
    const inverted = invertKv(all);
    exports.from = lcidCode => {
        if (typeof lcidCode !== 'number') {
            throw new TypeError('Expected a number');
        }
        return inverted[lcidCode];
    };
    exports.to = localeId => {
        if (typeof localeId !== 'string') {
            throw new TypeError('Expected a string');
        }
        return all[localeId];
    };
    exports.all = all;
}
